import lozad from 'lozad';
import mixitup from 'mixitup';
export default {
  init() {
    // JavaScript to be fired on all pages
    const observer = lozad();
    observer.observe();

    (function($) {
      // Mobile Nav
      $('#nav-primary-toggle').click(function() {
        $('.nav-primary').toggleClass('open');
        $('.nav-backdrop').toggleClass('show');
      });

      $('#menu-header-menu li.menu-item-has-children').append('<div class="menu-chevron toggle absolute z-20 top-0 right-0 bottom-0 px-2 py-1"><svg class=""version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="15px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve"> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441 L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082 c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647 c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"/> </svg></div>');

      var timing = 200;

    $('.toggle').on('click', function(e) {
      e.stopPropagation()
      const toggle = $(this)
      const parentItem = toggle.closest('li.menu-item-has-children')
      const submenu = parentItem.children('.sub-menu')
      parentItem
        .siblings('.menu-item-has-children')
        .removeClass('open')
        .children('.sub-menu')
        .slideUp(timing)
      if (parentItem.hasClass('open')) {
        parentItem.removeClass('open')
        submenu.slideUp(timing)
      } else {
        parentItem.addClass('open')
        submenu.slideDown(timing)
      }
    })

      // Desktop nav
      $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').on('hover', function() {
        if( $(window).innerWidth() > 991 ) {
          var target = $(this).find('> ul.sub-menu');
          var width = $(target).outerWidth();

          var right_of_screen = $(window).innerWidth();
          var right_of_parent = $(this).offset().left + $(this).outerWidth();
          var right_of_element = right_of_parent + width;

          if (right_of_screen > right_of_element){
            $(target).css('transform', 'translateX(100%)');
            $(target).css('right', '0');
          } else {
            $(target).css('transform', 'translateX(-100%)');
            $(target).css('left', '0');
          }
        }
      });

      $('.slick-banner').on('init', function() {
        var hiddenSlides = $('.slick-banner .hidden');
        if(hiddenSlides.length > 1) {
          $('.slick-banner .hidden').each(function(i, el) {
            $(el).removeClass('hidden');
          })
        } else {
          hiddenSlides.removeClass('hidden');
        }
      })

      // Slick
      $('.slick-banner').slick({
        dots: true,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.slick-p').click(function() {
        $(this).parent().prev().slick('slickPrev');
      });
      $('.slick-n').click(function() {
        $(this).parent().prev().slick('slickNext');
      });

      // Cookie Policy
      $.fn.CookieNotice = function() {
        if (!localStorage.getItem('cookie-notice-dismissed')) {
          var notice = this;
          setTimeout(function() {
            notice.addClass('active');
          }, 1000);
        }
        this.addClass('cookie-notice');
        return this
      }
      $(document).on('click', '.cookie-notice-dismiss', function() {
        localStorage.setItem('cookie-notice-dismissed', true);
        $(this).parents('.cookie-notice').removeClass('active');
      })
      $('#cookie-notice').CookieNotice();

      // Share Button
      $('.page-share').click(function() {
        if( navigator.share ) {
          navigator.share({
            title: 'Share This Page',
            url: 'https://google.com',
          }).then(() => {
            console.log('Thanks for sharing!');
          })
          .catch(err => {
            console.log('Couldnt share because of', err.message);
          });
        } else {
          $('#panel-share').toggleClass('active');
          console.log('navigator.share not supported!')
        }
      });

      $('.panel-share-close').click(function() {
        $('#panel-share').removeClass('active');
      });

      // Media tabs

      $('.tab-link').click( function() {
      var tabID = $(this).attr('data-tab');
      $(this).addClass('active').siblings().removeClass('active');
      $('#tab-'+tabID).addClass('active').siblings().removeClass('active');
      console.log('testing tabbed')
      });

      // slick sliders

      $('.product-slider').slick({
          dots: false,
          arrows: true,
          autoplay: true,
          infinite: true,
          swipeToSlide: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          lazyload: 'progressive',
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });

        $('.image-slider').slick({
            dots: false,
            arrows: true,
            autoplay: true,
            infinite: true,
            swipeToSlide: true,
            speed: 300,
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 3,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          });

          $('.news-slider').slick({
              dots: true,
              arrows: false,
              autoplay: true,
              infinite: true,
              swipeToSlide: true,
              speed: 300,
              slidesToShow: 2,
              slidesToScroll: 2,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });

            $('.accreditation-slider').slick({
                dots: true,
                arrows: false,
                autoplay: true,
                swipeToSlide: true,
                speed: 300,
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                    },
                  },
                ],
              });

            $('.testimonial-slider').slick({
                dots: false,
                centerMode: true,
                arrows: false,
                autoplay: true,
                infinite: true,
                swipeToSlide: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 2,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 2,
                      centerMode: false,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    },
                  },
                ],
              });


              // Manychat

              function loadScript( url, callback, type ) {
                var script = document.createElement( 'script' )
                script.type = 'text/javascript';
                if(script.readyState) {  // only required for IE <9
                  script.onreadystatechange = function() {
                    if ( script.readyState === 'loaded' || script.readyState === 'complete' ) {
                      script.onreadystatechange = null;
                      callback();
                    }
                  };
                } else {  //Others
                  script.onload = function() {
                    callback();
                  };
                }  script.src = url;
                if(type == 'widget-js'){
                  script.setAttribute('gfspw','https://customerfeedback.reviewability.com/popup-pixel/get/f325962d686e10d22aee813070d1383856822ae4?clientId=102867');
                }
                document.getElementsByTagName( 'head' )[0].appendChild( script );
              }

              var loadChat = function() {
                      if (window.scrollY >= 420) {
                          window.removeEventListener('scroll',loadChat)
                          window.__be = window.__be || {};
                          window.__be.id = '64ccbe988376910007ecff89';
                          var be = document.createElement('script');
                          be.type = 'text/javascript';
                          be.async = true;
                          be.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.chatbot.com/widget/plugin.js';
                          var s = document.getElementsByTagName('script')[0];
                          s.parentNode.insertBefore(be, s);
                      }
              }
              var loadReview = function() {
                window.removeEventListener('scroll', loadReview);
                loadScript('https://widget.reviewability.com/js/popupWidget.min.js', function(){}, 'widget-js');
              }

              // window.addEventListener('scroll', loadChat)
              // window.addEventListener('scroll', loadReview)


// CTA

$(window).scroll(function() {

  if ($(document).scrollTop() > 500) {
    $('.offcanvas-cta').show();
    $('.offcanvas-cta').addClass('offcanvas-show');
  }
  else {
    $('.offcanvas-cta').hide();
    $('.offcanvas-cta').removeClass('offcanvas-show');
  }

  if ($(document).scrollTop() > 650) {
    $('.offcanvas-cta').addClass('offcanvas-minimise');
  }
  else {
    $('.offcanvas-cta').removeClass('offcanvas-minimise');
  }
})

$('.side-sticky-cta').stick_in_parent();

        // FAQ & Product info Control

        $('.faq-wrapper .heading').each(function (i, el) {
          $(el).on('click', function () {
            $(el).parent().toggleClass('collapsed');
          })
        })


        // Smooth scroll

        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 300,
            }, 500);
        });

        // LAZYLOAD IFRAMES

        document.addEventListener('DOMContentLoaded',
        function() {
          var div, n,
            v = document.getElementsByClassName('youtube-player');
          for (n = 0; n < v.length; n++) {
            div = document.createElement('div');
            div.setAttribute('data-id', v[n].dataset.id);
            div.innerHTML = labnolThumb(v[n].dataset.id);
            div.onclick = labnolIframe;
            v[n].appendChild(div);
          }
        });

        function labnolThumb(id) {
          var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
          play = '<div class="play"></div>';
          return thumb.replace('ID', id) + play;
        }

        function labnolIframe() {
          var iframe = document.createElement('iframe');
          var embed = 'https://www.youtube.com/embed/ID?autoplay=1&rel=0&modestbranding=1';
          iframe.setAttribute('src', embed.replace('ID', this.dataset.id));
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allowfullscreen', '1');
          this.parentNode.replaceChild(iframe, this);
        }

        // LAZYLOAD NEW

        $('.showroom-player').click(function(){
          var iframeSrc = $(this).data('iframe-src');

          $(this).find('img').hide();
          $(this).append(iframeSrc);

        });

        $('.iframe-player').click(function(){
          var iframeSrc = $(this).data('iframe-src');
          $(this).addClass('embed-responsive embed-responsive-16by9');
          $(this).removeClass('flex');
          $(this).find('img').hide();
          $(this).append('<iframe src="'+ iframeSrc +'" width="100%" height="100%" class="embed-responsive-item" allowfullscreen></iframe>')

        });
        $('.video-player').click(function(){
          var iframe = $(this).data('iframe');

          $(this).find('img').hide();
          $(this).find('.fa-play').hide();
          $(this).find('.play-overlay').hide();
          $(this).append('<iframe src="https://www.youtube.com/embed/' + iframe + '" width="100%" height="100%" class="embed-responsive-item" allowfullscreen></iframe>');

        });

        // Window on scroll

        $(window).scroll(function(){
          if($(window).scrollTop() === 0) {
             $('.banner').css('background-color', 'transparent');
           } else {
             $('.banner').css('background-color', '#244545');
           }
        });

        if($('.mix-container').length){
        var mixer = mixitup('.mix-container');
        if(mixer) {
          console.log('mix');
        }
      }
        $('.gallery-btn').click(function(){
          $('.center-img').css('top', '0px');
        });
        $('.gallery-reset').click(function(){
          $('.center-img').css('top', '-30px');
        });


    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js